import { inject, Injectable } from '@angular/core';
import { AccommodationsControllerApiService } from '@lx/shared/api';
import { BathroomType, MealOption, ProductAccommodation } from '@lx/shared/data-access/products';
import { getLocale } from '@lx/shared/i18n';
import { getCompanyHeader } from '@lx/shared/tokens';
import { Memoize } from '@lx/shared/utils-http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccommodationService {
  private readonly locale = getLocale();
  private readonly companyHeader = getCompanyHeader();

  private readonly accommodationsApiService = inject(AccommodationsControllerApiService);

  public bathRoomTypeLabels: Record<BathroomType, string> = {
    PRIVATE: $localize`Private`,
    SHARED: $localize`Shared`,
  };
  public mealOptionLabels: Record<MealOption, string> = {
    NO_MEALS: $localize`No Meals`,
    BED_BREAKFAST: $localize`Breakfast`,
    HALF_BOARD: $localize`Half Board`,
    MEAL_PLAN: $localize`Meal Plan`,
  };

  @Memoize((schoolId: string, courseId: string, tripDate?: string) => [schoolId, courseId, tripDate].join('|'))
  public getByCourse(schoolId: string, courseId: string, tripDate?: string): Observable<ProductAccommodation[]> {
    return this.accommodationsApiService.findAccommodationsByCourse(+schoolId, +courseId, this.locale, this.companyHeader, tripDate);
  }
}
